// extracted by mini-css-extract-plugin
export var brand = "styles-module--brand--4c6c3";
export var brandTypeContainer = "styles-module--brandTypeContainer--056ff";
export var dark = "styles-module--dark--1bd76";
export var exmoxPrimary = "styles-module--exmoxPrimary--12e70";